import { BrowserModule } from '@angular/platform-browser';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA, LOCALE_ID } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { AppComponent } from './app.component';
import { NavMenuComponent } from './components/nav-menu/nav-menu.component';
import { HomeComponent } from './components/home/home.component';
import { DebitCardPaymentComponent } from './components/debit-card-payment/debit-card-payment.component';
import { PixPaymentComponent } from './components/pix-payment/pix-payment.component';
import { CreditCardPaymentComponent } from './components/credit-card-payment/credit-card-payment.component';
import { OrderTrackingComponent } from './components/order-tracking/order-tracking.component';
import { OrderBlockedComponent } from './components/order-blocked/order-blocked.component';
import { OrderServiceComponent } from './components/order-service/order-service.component';
import { SettingComponent } from './components/setting/setting.component';
import { AccountComponent } from './components/account/account.component';
import { AuthenticationComponent } from './components/authentication/authentication.component';
import { AccordionModule } from '@syncfusion/ej2-angular-navigations';
import { SelectDropDownModule } from 'ngx-select-dropdown'
import { NgxPaginationModule } from 'ngx-pagination';
import { NgxInputSearchModule } from 'ngx-input-search';
import { ModalDialogModule } from 'ngx-modal-dialog';
import { NgxLoadingModule } from 'ngx-loading';
import { CancelModalComponent } from './components/modal-cancel-component/modal-cancel-component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppMaterialModule } from './app.material.module';
import { AppRoutingModule } from './app-routing.module';
import { OrderTrackingService } from './components/order-tracking/services/order-tracking.service';
import { OrderBlockedService } from './components/order-blocked/services/order-blocked.service';
import { OrderTrackingServiceRest } from './components/order-tracking/services/order-tracking.service-rest';
import { OrderBlockedServiceRest } from './components/order-blocked/services/order-blocked.service-rest';
import { OrderServiceRest } from './components/order-service/services/order-service.service-rest';
import { SettingServiceRest } from './components/setting/services/setting.service-rest';
import { AccountServiceRest } from './components/account/services/account.service-rest';
import { OrderService } from './components/order-service/services/order-service.service';
import { SettingService } from './components/setting/services/setting.service';
import { AccountService } from './components/account/services/account.service';
import { BoolToAffirmation } from './common/custom.datepipe';
import { StoreModule } from '@ngrx/store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { appReducers } from './modules/manager-home/store';
import { registerLocaleData } from '@angular/common';
import ptBr from '@angular/common/locales/pt';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatTabsModule } from '@angular/material/tabs';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

registerLocaleData(ptBr)


@NgModule({
  declarations: [
    AppComponent,
    NavMenuComponent,
    HomeComponent,
    DebitCardPaymentComponent,
    CreditCardPaymentComponent,
    PixPaymentComponent,
    OrderTrackingComponent,
    OrderBlockedComponent,
    OrderServiceComponent,
    SettingComponent,
    AccountComponent,
    AuthenticationComponent,
    CancelModalComponent,
    BoolToAffirmation
  ],
  imports: [
    BrowserModule.withServerTransition({ appId: 'ng-cli-universal' }),
    HttpClientModule,
    FormsModule,
    AccordionModule,
    SelectDropDownModule,
    BrowserAnimationsModule,
    AppMaterialModule,
    NgxPaginationModule,
    NgxInputSearchModule,
    ModalDialogModule.forRoot(),
    NgxLoadingModule.forRoot({}),
    AppRoutingModule,
    StoreModule.forRoot(appReducers),
    StoreDevtoolsModule.instrument({ maxAge: 25 }),
    MatSidenavModule,
    MatTabsModule,
    NgbModule
  ],
  entryComponents: [CancelModalComponent],
  providers: [
    OrderTrackingService,
    OrderTrackingServiceRest,
    OrderBlockedService,
    OrderBlockedServiceRest,
    OrderServiceRest,
    OrderService,
    SettingService,
    SettingServiceRest,
    AccountService,
    AccountServiceRest,
    { provide: LOCALE_ID, useValue: 'pt' }],
  bootstrap: [AppComponent]

})
export class AppModule { }
